module.exports = __webpack_public_path__ + "static/media/onboarding-users.en.04d9be01.png";